import RelationIconSvg from "src/assets/icons/ManyToOne.svg?react";

export const ManyToOneRelationIcon = () => (
  <span className="flex justify-center p-1">
    <RelationIconSvg height={12} width={12} />
  </span>
);
